export enum CountryPL {
    POLAND = "Polska",
    SPAIN = "Hiszpania"
}
export enum CountryPL {
    POLAND = "Polska",
    SPAIN = "Hiszpania"
}
